import React from 'react';
import EditorialLayout from '@/components/editorial/EditorialLayout';

const EditorialPage: React.FC = () => {
  return (
    <EditorialLayout>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Editorial Dashboard</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Content Management</h2>
            <p className="text-gray-600">Manage and organize editorial content</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Publishing Queue</h2>
            <p className="text-gray-600">Review and publish pending content</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Analytics</h2>
            <p className="text-gray-600">View editorial performance metrics</p>
          </div>
        </div>
      </div>
    </EditorialLayout>
  );
};

export default EditorialPage;